"use client";

import { BannerWithTitleOnly } from "#app/_ui/components/banners/BannerWithTitleOnly";
import { FactsetDisclaimers } from "#app/_ui/components/market-research/factset-disclaimers";
import { StockMostTradedInstruments } from "#app/_ui/components/market-research/stock-most-traded-instruments";
import { StockTopFlop } from "#app/_ui/components/market-research/stock-top-flop";
import { useStockLinkClick } from "#app/_ui/components/market-research/use-stock-link-click";
import { Card, CardContent, CardHeader } from "#ui/card";
import { Container } from "#ui/container";
import { Main } from "#ui/main";
import { H2 } from "#ui/typography";

export function StocksContent() {
  const stockLinkClick = useStockLinkClick();

  return (
    <Main>
      <BannerWithTitleOnly title="Stocks" />
      <Container>
        <div className="grid gap-y-30px">
          <Card>
            <CardHeader>
              <H2 size="h5">Gainers</H2>
            </CardHeader>
            <CardContent>
              <StockTopFlop symbolLinkClick={stockLinkClick} type="gainers" />
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <H2 size="h5">Losers</H2>
            </CardHeader>
            <CardContent>
              <StockTopFlop symbolLinkClick={stockLinkClick} type="losers" />
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <H2 size="h5">Most Active</H2>
            </CardHeader>
            <CardContent>
              <StockMostTradedInstruments symbolLinkClick={stockLinkClick} />
            </CardContent>
          </Card>
          <FactsetDisclaimers />
        </div>
      </Container>
    </Main>
  );
}
